import React from 'react';
import Tooltip from '../../Tooltip';

type Props = {
  onClick: () => void;
  label: string;
};

const ClosedCaptionsReturn = ({ onClick, label }: Props) => {
  return (
    <Tooltip
      content={label}
      size="medium"
      theme="dark"
      pointerPosition="top-center"
    >
      <button
        type="button"
        className="closed-captions-return"
        onClick={onClick}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 25 25"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.08055 8.37967C6.49179 8.01102 7.12401 8.04554 7.49266 8.45678L12.432 13.9667C12.6204 14.1768 12.8757 14.1768 13.0641 13.9667L18.0034 8.45678C18.3721 8.04554 19.0043 8.01102 19.4156 8.37967C19.8268 8.74832 19.8613 9.38054 19.4927 9.79178L14.5533 15.3017C13.5701 16.3985 11.926 16.3985 10.9428 15.3017L6.00345 9.79178C5.6348 9.38054 5.66932 8.74832 6.08055 8.37967Z"
            fill="currentColor"
          />
        </svg>
      </button>
    </Tooltip>
  );
};

export default ClosedCaptionsReturn;
